import React, {useState} from "react";
import CommonCertificateNotesForm from "../../../../components/common/CertificateNotesGrid/CertificateNotesGrid";
import {useParams} from "react-router-dom";
import {
    useDeleteCertificateNoteByIdMutation,
    useGetCertificateNotesByReferenceIdQuery
} from "../../../../components/common/CertificateNotesGrid/CertificateNotesApi";
import CertNoteAddOrUpdateModal from "../../../../components/common/CertificateNotesGrid/CertNoteAddOrUpdateModal";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";

type SubdivisionDetailInfoProps = {
    parentAccountData: any;

};

const SubdivisionCertificateNote: React.FC<SubdivisionDetailInfoProps> = ({parentAccountData}) => {

    const {subdivisionId} = useParams();
    const [certificateNoteId, setCertificateNoteId] = useState(null);
    const [showManagementCertificateModal, setShowManagementCertificateModal] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteNotesApi, {isLoading}] = useDeleteCertificateNoteByIdMutation();
    const [showNoteUpdateModel, setShowNoteUpdateModel] = useState(false);

    const [noteObject, setNoteObject] = useState(null);
    const {
        data: certificateNotes,
    } = useGetCertificateNotesByReferenceIdQuery(subdivisionId || "");


    const handleDeleteCertificateNotes = async (e: any) => {
        e.preventDefault();
        if (certificateNoteId !== null && certificateNoteId !== '') {
            try {
                await deleteNotesApi(certificateNoteId);
                setShowDeleteConfirm(false);
            } catch (error) {
                console.error('Error deleting certificate note:', error);
            }
        }
    };

    return (
        <div className={"mt-3"}>

            <CommonCertificateNotesForm
                title={"Subdivision Certificate Notes"}
                data={certificateNotes}
                relationalId={subdivisionId}
                count={certificateNotes?.length || 0}
                setShowAddNoteModal={setShowManagementCertificateModal}
                setNoteObject={setNoteObject}
                setShowNoteUpdateModel={setShowNoteUpdateModel}
                setNoteId={setCertificateNoteId}
                setShowDeleteConfirm={setShowDeleteConfirm}
            />
            {showManagementCertificateModal &&
                <CertNoteAddOrUpdateModal title={"Add Subdivision Certificate Note"}
                                          show={showManagementCertificateModal}
                                          setShow={setShowManagementCertificateModal}
                                          relationalId={subdivisionId}
                                          type={"Subd"}
                                          length={certificateNotes && certificateNotes.length + 1}
                                          isFulfillmentNotes={true}
                                          parentAccountData={parentAccountData}
                                          btnName="Add"/>}
            {showNoteUpdateModel &&
                <CertNoteAddOrUpdateModal title={"Update Subdivision Certificate Note"}
                                          show={showNoteUpdateModel}
                                          setShow={setShowNoteUpdateModel}
                                          noteObj={noteObject}
                                          relationalId={subdivisionId}
                                          isFulfillmentNotes={true}
                                          parentAccountData={parentAccountData}
                                          btnName={"Update"} type={"Subd"}
                />
            }

            {showDeleteConfirm && <ConfirmationModal title={"Delete Subdivision Certificate Note"}
                                                     bodyMessage={"Are you sure you want to delete this Certificate note?"}
                                                     onSubmit={handleDeleteCertificateNotes}
                                                     show={showDeleteConfirm}
                                                     setShow={setShowDeleteConfirm}
                                                     isLoading={isLoading}
            />}
        </div>
    );
};

export default SubdivisionCertificateNote;
